























































import VueOptions from '@utils/VueOptions'
import WizardNavigation from '@superComponents/Organizer/TransferWizard/WizardNavigation'

settings =
  name: 'OverviewStep'

  vue:
    props: ['wizard', 'step']

    components: {
      WizardNavigation,
    }

    methods:
      hiSameAccount: ->
        @wizard.resetForm()
        @wizard.setSameAccount()
        @wizard.navToStepName 'setup-same-account'

      hiDifferentAccount: ->
        @wizard.resetForm()
        @wizard.setDifferentAccount()
        @wizard.navToStepName 'setup-different-account'

export default VueOptions.vue settings
